export const ChatMessage = ({ isBlocked, isAlreadyMember, isTyping, latestMessage, languageCode, isUserBlock }
  : { isBlocked: Boolean, isAlreadyMember: Boolean, isTyping: Boolean, latestMessage: any, languageCode: any, isUserBlock: Boolean }) => {
  /**
   * DETERMINE DISPLAY MESSAGE
   * Logic determines what text to show based on channel state
   * PRIORITY:
   * 1. Blocked state (highest priority)
   * 2. Membership state (JOIN vs message preview)
   * 3. Typing indicator
   * 4. Latest message (default)
   */
  let displayMessage;
  
  if (isBlocked) {
    // Channel or user is blocked
    if (isUserBlock) {
      // Current user was blocked by other user
      displayMessage = languageCode['You have been blocked.'];
    }
    else {
      // Current user blocked the other participant
      displayMessage = languageCode['Blocked Participant'];
    }
  } else {
    // Channel is not blocked
    displayMessage = isAlreadyMember
      ? (isTyping ? languageCode['typing...'] : latestMessage) // Member: show typing or last message
      : languageCode['JOIN']; // Not member: show JOIN button
  }

  /**
   * RENDER
   * CONDITIONAL RENDERING:
   * - If message is "JOIN" → render as button style
   * - Otherwise → render as paragraph text
   * STYLING:
   * - chat-message__join-button: Button appearance for JOIN
   * - chat-message__text: Normal text appearance for messages
   */
  return (
    <>
      {displayMessage === languageCode['JOIN'] ? (
        <div className="chat-message__join-button">{displayMessage}</div>
      ) : (
        <p className="chat-message__text">{displayMessage}</p>
      )}
    </>
  );

};

export default ChatMessage;
